// Shared chart configuration for consistent styling across all pages
// Uses CSS variables for theme support (dark/light)

export const GRID = {
  stroke: 'var(--border-primary, rgba(255,255,255,0.05))',
  horizontal: true,
  vertical: false,
};

export const AXIS_TICK = {
  fill: 'var(--text-muted, #94a3b8)',
  fontSize: 10,
  fontWeight: 500,
  fontFamily: 'inherit',
};

export const AXIS_PROPS = {
  axisLine: false,
  tickLine: false,
  tick: AXIS_TICK,
};

export const TOOLTIP_STYLE = {
  contentStyle: {
    background: 'var(--bg-elevated, #1e293b)',
    border: '1px solid var(--border-hover, rgba(255,255,255,0.08))',
    borderRadius: 10,
    fontSize: 12,
    fontFamily: 'inherit',
    color: 'var(--text-primary, #f1f5f9)',
    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
    padding: '8px 12px',
  },
  itemStyle: { color: 'var(--text-secondary, #cbd5e1)', fontSize: 11 },
  labelStyle: { color: 'var(--text-muted, #94a3b8)', fontWeight: 600, fontSize: 11, marginBottom: 4 },
};

export const LEGEND_STYLE = {
  wrapperStyle: {
    fontSize: 10,
    fontFamily: 'inherit',
    color: 'var(--text-muted, #94a3b8)',
    paddingTop: 8,
  },
  iconType: 'circle',
  iconSize: 8,
};

export const ANIMATION = {
  animationDuration: 800,
  animationEasing: 'ease-out',
};

export const CHART_DEFAULTS = {
  strokeWidth: 1.5,
  dot: false,
  activeDot: { r: 3 },
};

// Formatting helpers
export function fmtCompact(n) {
  if (n == null || isNaN(n)) return '0';
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return (n / 1_000_000).toFixed(1).replace('.', ',') + 'M';
  if (abs >= 1_000) return (n / 1_000).toFixed(0) + 'k';
  return n.toFixed(0);
}

export function fmtEur(n) {
  if (n == null || isNaN(n)) return '0,00 €';
  return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

export function fmtPct(n) {
  if (n == null || isNaN(n)) return '0,0%';
  return (n >= 0 ? '+' : '') + n.toFixed(1).replace('.', ',') + '%';
}

// Color helpers
export function withOpacity(hex, opacity) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${opacity})`;
}
